// AUTO-GENERATED by scripts/generate-build-info.js — do not edit by hand.
// Regenerated on every `npm run build`. A placeholder ships in git so a
// fresh checkout still compiles before the first build runs this script.
export const buildInfo = {
  commitHash: '045b5af1c',
  commitFullHash: '045b5af1c523e8c423e824880551698c7febec58',
  branch: 'HEAD',
  commitDate: '2026-10-22T11:11:02+05:30',
  buildTime: '2026-10-22T11:38:50.260Z',
};
